import React from 'react';

export const HomepageBannerConfetti = () => (
  <svg
    viewBox="0 0 328 156"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>confetti</title>
    <defs>
      <polygon
        id="path-1"
        points="5.0000001e-05 0.000245000005 19.2300504 0.000245000005 19.2300504 35.2800007 5.0000001e-05 35.2800007"
      />
      <polygon
        id="path-3"
        points="-4.00000006e-05 0.365600005 21.2944003 0.365600005 21.2944003 15.5999523 -4.00000006e-05 15.5999523"
      />
      <polygon
        id="path-5"
        points="0.239320004 0.149431411 21.4028003 0.149431411 21.4028003 15.1894802 0.239320004 15.1894802"
      />
      <polygon
        id="path-7"
        points="0 0.00412000006 13.1119602 0.00412000006 13.1119602 14.8000002 0 14.8000002"
      />
      <polygon
        id="path-9"
        points="0 0.365600005 21.2944003 0.365600005 21.2944003 15.6000002 0 15.6000002"
      />
      <polygon
        id="path-11"
        points="0 0.275200004 15.4898802 0.275200004 15.4898802 11.3226002 0 11.3226002"
      />
      <polygon
        id="path-13"
        points="0 0.275200004 15.4898802 0.275200004 15.4898802 11.3226002 0 11.3226002"
      />
      <polygon
        id="path-15"
        points="4.73469346e-05 0 18.2096784 0 18.2096784 33.4079506 4.73469346e-05 33.4079506"
      />
      <polygon
        id="path-17"
        points="0 0.0460000007 16.0690402 0.0460000007 16.0690402 13.6886552 0 13.6886552"
      />
      <polygon
        id="path-19"
        points="-0.000120000002 0.0460400007 15.1998802 0.0460400007 15.1998802 8.00000012 -0.000120000002 8.00000012"
      />
      <polygon
        id="path-21"
        points="0.000228450542 0.26083679 18.9974168 0.26083679 18.9974168 23.1279991 0.000228450542 23.1279991"
      />
    </defs>
    <g id="RUTR-(Mob)" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Homepage" transform="translate(-27.000000, -219.000000)">
        <g id="RUTR-CTA" transform="translate(20.000000, 218.000000)">
          <g id="Artwork" transform="translate(0.000000, 0.696809)">
            <g id="confetti" transform="translate(7.000000, -6.000000)">
              <g>
                <g id="Group-3" transform="translate(216.000000, 161.303191)">
                  <mask id="mask-2" fill="white">
                    <use xlinkHref="#path-1" />
                  </mask>
                  <g id="Clip-2" />
                </g>
                <path
                  d="M2,16.9921997 L10.0555556,12.099844 C10.0555556,12.099844 14.8888889,10.8767551 19.3194444,16.9921997 C23.75,23.1076443 26.5694444,23.1076443 31,23.1076443 L22.9444444,28 C22.9444444,28 17.3055556,28 14.8888889,24.7384295 C12.4722222,21.4768591 10.4583333,16.9921997 2,16.9921997"
                  id="Fill-1"
                  fill="#FACB02"
                />
                <path
                  d="M319.52496,35.9482001 C317.57096,34.7038001 316.40016,31.1998001 316.40016,31.1998001 C313.19976,31.1998001 308.00016,30.3998001 308.00016,30.3998001 C308.00016,33.5998001 311.20016,37.9998002 311.20016,37.9998002 C311.20016,37.9998002 315.99696,38.7978002 319.52496,35.9482001"
                  id="Fill-1"
                  fill="#56A285"
                />
                <g id="Group-5" transform="translate(311.200000, 26.034560)">
                  <mask id="mask-4" fill="white">
                    <use xlinkHref="#path-3" />
                  </mask>
                  <g id="Clip-4" />
                  <path
                    d="M-4.00000006e-05,11.9654002 C-4.00000006e-05,11.9654002 11.99996,13.9654002 11.99996,0.365400005 C11.99996,0.365400005 19.5999603,1.16540002 21.1999603,1.16540002 C21.1999603,1.16540002 22.4819603,10.5246002 15.5999602,13.9654002 C7.59996011,17.9654003 1.59996002,13.5654002 -4.00000006e-05,11.9654002"
                    id="Fill-3"
                    fill="#89C79D"
                    mask="url(#mask-4)"
                  />
                </g>
                <g id="Group-7" transform="translate(98.000000, 4.000000)">
                  <g id="Group-3" transform="translate(3.200000, 0.250640)">
                    <mask id="mask-6" fill="white">
                      <use xlinkHref="#path-5" />
                    </mask>
                    <g id="Clip-2" />
                    <path
                      d="M0.239320004,15.1894802 C0.239320004,15.1894802 5.94652009,3.70428006 21.4029203,8.93308013 L15.2889202,0.322680005 C15.2889202,0.322680005 3.09692005,-2.55972004 0.239320004,15.1894802"
                      id="Fill-1"
                      fill="#2E87C9"
                      mask="url(#mask-6)"
                    />
                  </g>
                  <g id="Group-6" transform="translate(0.000000, 8.250640)">
                    <mask id="mask-8" fill="white">
                      <use xlinkHref="#path-7" />
                    </mask>
                    <g id="Clip-5" />
                    <path
                      d="M13.1119602,0.00412000006 C6.20916009,1.61972002 3.43916005,7.18932011 3.43916005,7.18932011 C3.44796005,7.13652011 3.45756005,7.08572011 3.46636005,7.0325201 C1.92436003,10.2193202 -4.00000006e-05,10.7461202 -4.00000006e-05,10.7461202 L7.82076012,14.8001202 C9.71396014,13.1213202 11.9139602,9.31092014 11.7819602,5.53972008 C11.6683602,2.29572003 12.7943602,0.456120007 13.1119602,0.00412000006"
                      id="Fill-4"
                      fill="#3365A6"
                      mask="url(#mask-8)"
                    />
                  </g>
                </g>
                <g id="Group-6" transform="translate(275.000000, 81.303191)">
                  <g id="Group-5" transform="translate(0.200000, 0.034560)">
                    <mask id="mask-10" fill="white">
                      <use xlinkHref="#path-9" />
                    </mask>
                    <g id="Clip-4" />
                  </g>
                </g>
                <g id="Group-5" transform="translate(88.000000, 138.303191)">
                  <path
                    d="M7.16400011,15.5242802 C9.21880014,16.5942802 12.8388002,15.8562802 12.8388002,15.8562802 C14.4388002,18.6274803 17.7312003,22.7310803 17.7312003,22.7310803 C14.9600002,24.3310804 9.54960014,23.7594804 9.54960014,23.7594804 C9.54960014,23.7594804 6.4604001,20.0046803 7.16400011,15.5242802"
                    id="Fill-1"
                    fill="#E6A501"
                  />
                  <path
                    d="M8.30264012,8.00000012e-05 C8.30264012,8.00000012e-05 -0.443360007,3.56928005 0.0178400003,11.2496802 C0.553440008,20.1780803 7.36384011,23.1740803 9.54984014,23.7596804 C9.54984014,23.7596804 1.81784003,14.3672802 13.5954402,7.56728011 C13.5954402,7.56728011 9.10264014,1.38568002 8.30264012,8.00000012e-05"
                    id="Fill-3"
                    fill="#FACB02"
                  />
                </g>
                <g id="Group-6" transform="translate(258.000000, 0.000000)">
                  <path
                    d="M6.7340001,3.16924005 C6.7340001,3.16924005 19.0356003,6.7952401 16.5704002,22.9248403 L23.9884004,15.4088402 C23.9884004,15.4088402 24.7096004,2.90124004 6.7340001,3.16924005"
                    id="Fill-1"
                    fill="#FACB02"
                  />
                  <g id="Group-5" transform="translate(0.000000, 0.124960)">
                    <mask id="mask-12" fill="white">
                      <use xlinkHref="#path-11" />
                    </mask>
                    <g id="Clip-4" />
                    <path
                      d="M15.4898802,11.3226002 C12.7002802,4.80540007 6.7338801,3.04420005 6.7338801,3.04420005 C6.7878801,3.04340005 6.8394801,3.04420005 6.8930801,3.04380005 C3.48708005,2.07900003 2.63388004,0.275000004 2.63388004,0.275000004 L-0.000120000002,8.68100013 C1.98148003,10.2538002 6.11628009,11.7586002 9.80708015,10.9738002 C12.9822802,10.2986002 14.9894802,11.0882002 15.4898802,11.3226002"
                      id="Fill-3"
                      fill="#E6A501"
                      mask="url(#mask-12)"
                    />
                  </g>
                </g>
                <g
                  id="Group-6"
                  transform="translate(325.638513, 145.310367) rotate(80.000000) translate(-325.638513, -145.310367) translate(317.638513, 138.810367)"
                >
                  <g id="Group-5" transform="translate(0.000000, 0.124960)">
                    <mask id="mask-14" fill="white">
                      <use xlinkHref="#path-13" />
                    </mask>
                    <g id="Clip-4" />
                  </g>
                </g>
                <g id="Group-3" transform="translate(316.000000, 57.000000)">
                  <mask id="mask-16" fill="white">
                    <use xlinkHref="#path-15" />
                  </mask>
                  <g id="Clip-2" />
                  <path
                    d="M5.6816795,33.4079506 L0.11367999,24.1279515 C0.11367999,24.1279515 -1.27831989,18.559952 5.6816795,13.4559524 C12.6416789,8.35195286 12.6416789,5.10395315 12.6416789,-4.63999959e-05 L18.2096784,9.27995278 C18.2096784,9.27995278 18.2096784,15.7759522 14.4976787,18.559952 C10.785679,21.3439517 5.6816795,23.6639515 5.6816795,33.4079506"
                    id="Fill-1"
                    fill="#C5679B"
                    mask="url(#mask-16)"
                  />
                </g>
                <g id="Group-7" transform="translate(266.000000, 42.000000)">
                  <g id="Group-3" transform="translate(0.000000, 0.354040)">
                    <mask id="mask-18" fill="white">
                      <use xlinkHref="#path-17" />
                    </mask>
                    <g id="Clip-2" />
                    <path
                      d="M16.0690402,12.5324002 C13.5998402,10.4460002 12.5214402,8.65280013 11.99984,6.046 C11.1998402,2.046 7.59984011,0.0460000007 7.59984011,0.0460000007 L-0.000160000002,5.64600008 C2.23984003,7.13920011 3.34984005,9.30880014 4.79984007,12.8460002 C9.99984,14.4460002 13.8430402,13.4368002 16.0690402,12.5324002"
                      id="Fill-1"
                      fill="#2E87C9"
                      mask="url(#mask-18)"
                    />
                  </g>
                  <g id="Group-6" transform="translate(4.800000, 11.554040)">
                    <mask id="mask-20" fill="white">
                      <use xlinkHref="#path-19" />
                    </mask>
                    <g id="Clip-5" />
                    <path
                      d="M-0.000120000002,1.64604002 C-0.000120000002,1.64604002 4.79988007,11.2460402 15.1998802,6.8460401 L13.5998802,0.0460400007 C13.5998802,0.0460400007 8.79988013,4.04604 -0.000120000002,1.64604002"
                      id="Fill-4"
                      fill="#3365A6"
                      mask="url(#mask-20)"
                    />
                  </g>
                </g>
                <g id="Group-6" transform="translate(0.000000, 103.000000)">
                  <g id="Group-3" transform="translate(0.000000, 0.131124)">
                    <mask id="mask-22" fill="white">
                      <use xlinkHref="#path-21" />
                    </mask>
                    <g id="Clip-2" />
                    <path
                      d="M18.9974168,14.8404922 C18.9974168,14.8404922 6.99084932,12.1278523 5.84503337,0.26083679 L0.0869455965,5.12908459 C0.0869455965,5.12908459 -1.82327033,16.1901482 12.2871611,23.1281559 C12.2871611,23.1281559 18.4874249,15.0580522 18.9974168,14.8404922"
                      id="Fill-1"
                      fill="#C5679B"
                      mask="url(#mask-22)"
                    />
                  </g>
                  <path
                    d="M0.0868671965,5.26001259 L0.443587182,4.9581726 C1.84577113,4.20122063 5.54625098,5.34154859 5.54625098,5.34154859 C3.12251507,7.25999651 2.29265111,14.2583722 2.25737111,14.5660922 C-0.662636773,9.61082041 0.0868671965,5.26001259 0.0868671965,5.26001259"
                    id="Fill-4"
                    fill="#A94B7D"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
